export default __webpack_public_path__ + "assets/powered_by_hg_logo.fa1c5f44.png";